import type { ExpirableMessage, Message } from '../../models/message.model'
import { isExpirableMessage } from '../../models/message.model'

export const getExpiresAt = (message: ExpirableMessage): string => {
  return message.type === 'photo' ? message.photo.expires_at : message.voice_message.expires_at
}

export const findNextMessageToExpire = (messages: Message[]): ExpirableMessage | undefined => {
  return messages
    .filter(isExpirableMessage)
    .reduce<
      ExpirableMessage | undefined
    >((soonest, msg) => (!soonest || getExpiresAt(msg) < getExpiresAt(soonest) ? msg : soonest), undefined)
}

export const isMessageExpired = (message: ExpirableMessage): boolean => {
  return new Date(getExpiresAt(message)).getTime() <= Date.now()
}

export const toExpiredEntity = (message: ExpirableMessage): Message => {
  const { boosted, fe_message_id, is_me, boostInProgress, timestamp, type } = message
  return {
    boosted,
    ...(fe_message_id !== undefined && { fe_message_id }),
    is_me,
    ...(boostInProgress !== undefined && { boostInProgress }),
    timestamp,
    type,
    status: 'expired',
  }
}
